<div class="row content-container">
  <div class="col-12 col-sm-12 main-content mynovi mynovi--history-order">
    <div class="button-bar button-bar--justify">
      <a [routerLink]="['/my/order/history']">
        <strong>
          <svg class="icon-arrow-left" height="10" width="6">
            <use xlink:href="/images/icons/svg-sprite.svg#arrow-left"></use>
          </svg>
          <span
            i18n="
              Back to order history link text@@history.detail.back.to.overview"
            >
            Back to order history
          </span>
        </strong>
      </a>
    </div>

    <!-- <span>'s binnen de h1 zorgen ervoor dat de datum en locatie los van elkaar op een nieuwe regel breken als het scherm kleiner wordt -->
    <h1 class="order-detail-title">
      @if (shipmentDate) {
        <span>{{
          shipmentDate | customDate: "EEEE dd MMMM"
        }}</span>
      }
      -
      @if (shipToName) {
        <span>{{ shipToName }} ({{ shipToCode }})</span>
      }
      @if (!shipToName) {
        <span>{{ shipToCode }}</span>
      }
    </h1>

    <div class="order-detail-info">
      <dl>
        <dt i18n="order history: shipping date@@shipping.date">
          Shipping date
        </dt>
        @if (shipmentDate) {
          <dd>
            {{ shipmentDate | customDate: "EEE dd MMM yy" }}
          </dd>
        }
      </dl>
      <dl>
        <dt i18n="order history: shipping destination@@shipping.destination">
          Shipping destination
        </dt>
        @if (shipToName) {
          <dd>{{ shipToName }} ({{ shipToCode }})</dd>
        }
        @if (!shipToName) {
          <dd>{{ shipToCode }}</dd>
        }
      </dl>
      <dl>
        <dt i18n="order history: total volume@@shipping.total.volume">
          Total volume
        </dt>
        <dd i18n="Calculated volume (CC)@@calculated.volume">
          {{ totalVolume | numberFormat: false }} CC
        </dd>
      </dl>
      <dl>
        <dt i18n="order detail: total volume cut@@shipping.volume.cut">
          Volume cut
        </dt>
        <dd i18n="Calculated volume (CC)@@calculated.volume">
          {{ totalVolumeCut | numberFormat: false }} CC
        </dd>
      </dl>
      <dl>
        <dt i18n="order detail: total volume plants@@shipping.volume.plants">
          Volume plants
        </dt>
        <dd i18n="Calculated volume (CC)@@calculated.volume">
          {{ totalVolumePlants | numberFormat: false }} CC
        </dd>
      </dl>
      <dl>
        <dt i18n="order detail: total volume misc@@shipping.volume.misc">
          Volume misc
        </dt>
        <dd i18n="Calculated volume (CC)@@calculated.volume">
          {{ totalVolumeMisc | numberFormat: false }} CC
        </dd>
      </dl>
    </div>

    <div
      class="button-bar button-bar--justify button-bar--va-bottom button-bar--mobile-block"
      >
      <div class="text-center" sales-person-telephone></div>
    </div>

    <div class="grid-container grid-table-filter-bar table-filter-bar">
      <div class="grid-item"></div>
      <div class="grid-item">
        <form class="overview-sort sortOnForm align-right">
          <label i18n="Barcode view: Sort on@@barcode.sort.on">Sort on:</label>
          <history-order-detail-sort
            (sortChangeEvent)="onSortOrderChange($event)"
            i18n-labelSortDescription="@@sort.on.description"
            i18n-labelSortPrice="@@sort.on.price"
            i18n-labelSortVolume="@@barcode.sort.on.volume"
            labelSortDescription="Description"
            labelSortPrice="Price"
            labelSortVolume="Volume"
            >
          </history-order-detail-sort>
        </form>
      </div>
    </div>

    <table class="order-overview-table order-overview-table--history-order">
      <thead>
        <tr>
          <th
            colspan="2"
            i18n="order history detail: product header@@order.product.header"
            scope="col"
            >
            Product
          </th>
          <th
            i18n="order history detail: amount header@@order.amount"
            scope="col"
            >
            Amount & unit
          </th>
          <th i18n="order history detail: pot size@@order.potsize" scope="col">
            Pot size
          </th>
          <th i18n="order history detail: height@@order.height" scope="col">
            Height
          </th>
          <th
            i18n="order history detail: volume header@@order.volume"
            scope="col"
            >
            Volume
          </th>
          <th
            i18n="order history detail: price header@@order.price"
            scope="col"
            >
            Price
          </th>
        </tr>
      </thead>
      <tbody>
        @for (line of historyDetails; track line) {
          <tr>
            <td
              [description]="line.productDescription"
              [height]="88"
              [imageFormat]="80"
              [image]="line.imageNo"
              [width]="88"
              class="order-overview-table_image"
              render-product-image
            ></td>
            <th class="order-overview-table_product" scope="row">
              {{ line.productDescription }}
              @if (line.vendorName) {
                <span
                  class="order-overview-table_product--vendor"
                  >{{ line.vendorName }}</span
                  >
                }
                @if (line.features) {
                  <span
                    class="order-overview-table_product--features"
                    >{{ line.features }}</span
                    >
                  }
                </th>
                <td class="order-overview-table_amount">
                  <span
              i18n="
                quantity ordered, formatted, eg: 1 x Tray
                (x6)@@shoppingcart.amount.tray"
                    >
              {{ line.quantityOrdered }} Tray (x {{ line.quantityPerBox }})
            </span>
                </td>
                <td class="order-overview-table_potsize">
                  <div class="order-overview-table_icon-text">
                    <svg
                      class="icon-potsize"
                      height="11"
                      viewBox="0 0 16 11"
                      width="16"
                      >
                      <use xlink:href="/images/icons/svg-sprite.svg#potsize"></use>
                    </svg>
                    <span>{{ line.potSize || "-" }}</span>
                  </div>
                </td>
                <td class="order-overview-table_height">
                  <div class="order-overview-table_icon-text">
                    <svg
                      class="icon-potheight"
                      height="11"
                      viewBox="0 0 6 11"
                      width="6"
                      >
                      <use xlink:href="/images/icons/svg-sprite.svg#potheight"></use>
                    </svg>
                    <span>{{ line.height || "-" }}</span>
                  </div>
                </td>
                <td
                  class="order-overview-table_volume"
                  i18n="Calculated volume (CC)@@calculated.volume"
                  >
            {{ line.volume | numberFormat: false }} CC
          </td>
                <td class="order-overview-table_price">
                  {{ applicationService.getUserCurrency() }}
                  {{ getPriceForLine(line) | numberFormat: true }}
                </td>
              </tr>
            }
          </tbody>
          <tfoot>
            <tr>
              <td
                class="order-overview-table_footer-total--label"
                colspan="5"
                i18n="order history detail : total@@order.detail.total"
                >
            Total:
          </td>
              <td
                class="order-overview-table_footer-total--volume"
                i18n="Calculated volume (CC)@@calculated.volume"
                >
            {{ totalVolume | numberFormat: false }} CC
          </td>
              <td class="order-overview-table_footer-total--price">
                {{ applicationService.getUserCurrency() }}
                {{ totalPrice | numberFormat: true }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
